<template>
  <ul class="flex flex-row gap-4">
    <li v-for="({ title, href, icon }, i) in links" :key="i">
      <a :href="href" rel="norefferer" target="_blank">
        <nuxt-img
          width="28"
          height="28"
          :src="icon"
          :alt="title"
          :title="title"
          format="webp"
        />
      </a>
    </li>
  </ul>
</template>
<script setup lang="ts">
const props = defineProps({
  white: {
    default: false,
    type: Boolean,
    required: false,
  },
});

interface Link {
  icon: string;
  title: string;
  href: string;
}

const links: Link[] = [
  {
    icon: props.white
      ? "/images/socials/facebookWhite.png"
      : "/images/socials/facebook.png",
    title: "Facebook",
    href: "https://www.facebook.com/AUTradelines/",
  },
  {
    icon: props.white
      ? "/images/socials/linkedinWhite.png"
      : "/images/socials/linkedin.png",
    title: "LinkedIn",
    href: "https://www.linkedin.com/company/au-tradelines/",
  },
];
</script>
